// utils/hooks/usePagePermission.ts
import { usePathname } from 'next/navigation';

import { getUserPermissions, hasPermission } from '..';
import { ROUTE_PERMISSIONS } from '../Permissions';

const ROUTES_WITHOUT_PERMISSION = [
  '/admin',
  '/admin/home',
  '/admin/home/page-config',
  '/admin/home/content-management',
  '/admin/home/parametrization',

  '/admin/home/navigation-page',
  '/admin/home/page-config/micro-site',
  '/admin/home/micro-sites',
  '/admin/home/micro-sites/default-sites',
  '/admin/home/micro-sites/dynamic-page',

  // Templates
  '/admin/home/templates',
];
export const usePagePermission = () => {
  const pathname = usePathname();
  //si encuentr ala ruta especifica explicitamente especificada, no se necesita permiso
  if (
    ROUTES_WITHOUT_PERMISSION.includes(pathname) ||
    pathname?.includes('/micro-sites/edit/') ||
    pathname?.includes('/admin/home/page-config/micro-site/') ||
    pathname?.includes('/admin/home/micro-sites/custom-sites/edit') ||
    pathname?.includes('/admin/home/micro-sites/dynamic-page/edit') ||
    pathname?.includes('/admin/home/micro-sites/templates/folder/') ||
    pathname?.includes('/admin/home/micro-sites/templates/edit/')
  ) {
    return { userHasPermission: true };
  }

  // quedate con las rutas que sean prefijo del pathname actual
  const routePermission = ROUTE_PERMISSIONS.filter((route) => pathname.startsWith(route.path))
    // si hay varias, la más larga es la más específica
    .sort((a, b) => b.path.length - a.path.length)[0];

  if (routePermission?.permission) {
    const userHasPermission = hasPermission(getUserPermissions(), routePermission.permission);
    return { userHasPermission };
  }

  return { userHasPermission: false };
};
